/**
 * @fileoverview GET handler for the "/datashares" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { datashares } from "./constants";
import type { GetDatasharesParams, GetDatasharesResult } from "./types";
import { isGetDatasharesResult } from "./validators";

export const getDatashares = reactQueryFetcherAdapter(
  datashares,
  (signal: AbortSignal, params: GetDatasharesParams): Promise<GetDatasharesResult> => {
    return fetch(
      "/datashares",
      "GET",
      params.snowflakeAccount ? { snowflake_account: params.snowflakeAccount } : {},
      { signal }
    );
  },
  isGetDatasharesResult
);
